import React, { useEffect, useReducer, createContext, useContext } from 'react';
import { format, parse } from 'date-fns';
import {saveAs} from 'file-saver'
import { LanguageContext } from "../../containers/Language/LanguageProvider";
import {
        FETCH_DATE_CONFIG, DISPLAY_ERROR_MESSAGE, SET_FROM_DATE, SET_UNTIL_DATE,
        FETCH_OVERVIEW_REQUEST, SET_OVERVIEW_DATA, FETCH_OVERVIEW_SUCCESS, FETCH_OVERVIEWDETAILS_SUCCESS,
        FETCH_OVERVIEWDETAILS_REQUEST, BACK_TO_OVERVIEW, ENABLE_EDITABLE_FIELDS, DISABLE_EDITABLE_FIELDS, SET_OVERVIEWDETAILS_DATA,
        SET_OVERVIEWDETAILS_TOTAL_FOOTER_DATA, SAVE_OVERVIEWDETAILS_REQUEST, SAVE_OVERVIEWDETAILS_SUCCESS, 
        RESET_UPDATED_AND_ERROR_FLAGS, SET_SHOW_INSTRUCTION_MODEL, DETAILOVERVIEW_REQUEST_OR_SUCCESS,
        SHOW_UPLOAD_FILE_MODEL, UPLOAD_CASH_REGISTER_REQUEST, UPLOAD_CASH_REGISTER_SUCCESS, LOGOUT_YES,
        SHOW_CASH_REGISTER_CONFIRMATION_MODEL , RESET_EDIT_TOGGLE_ON_BACK, SELECTED_OVERVIEWDETAIL_OPTION_CHANGE,
        CLEAR_FILTER, IS_DETAILS_FILTER_APPLIED, FETCH_REMARK_OPTIONS, SET_ERROR_LIST, 
        SET_CASH_REGISTER_MANDATORY, IS_OVERVIEW_FILTER_APPLIED, CLEAR_OVERVIEW_FILTER, SET_OVERVIEW_FILTER_DATA} 
    from '../actions/actionTypes';
import { fetchMetaData, fetchOverview, fetchOverviewDetails, updateOverviewRevenueDetails, 
         exportToExcelOverviewDetails, downloadCashRegister, uploadCashRegister, fetchRemarksOptions } from '../actions/actionSelectors';
import { overviewReducer } from '../actions/overview-reducer';
import { isNullOrUndefined } from 'util';
import config from '../../common/const/config';
import {OverviewDetailsOptions} from '../../common/const/OverviewDetailsOptions';
import {isValueNullOrUndefinedOrEmpty} from '../../common/utility/utility';

const initialState = {
    fromMinDate: undefined,
    fromRevenueDate: undefined,
    fromMaxDate: undefined,
    untilMinDate: undefined,
    untilRevenueDate: undefined,
    untilMaxDate: undefined,
    sessionTimeoutLimit: null,
    idleTimeoutLimit: null,
    overview: [],
    overviewDetails: [],
    revenueOverviewDetails: [],
    isError: false,
    errorMessage: "",
    isLoading: false,
    isBtnDetailsEnable: false,
    isShowDetailsClicked: false,
    showDetailRequestModel: undefined,
    isEnableEditableFields: false,
    isEditAccess: true, 
    isEditBtnToggle : true,
    isSuccessfullySaved: false,
    showModel: false,
    showInstructions: false,
    modelHeaderTitle: "",
    showUploadFileModel: false,
    acceptFileType: undefined,
    isFileUploadedSuccessfully: false,
    selectedRevenue: null,
    isCashRegister: false,
    selectedOverdetailsOption: OverviewDetailsOptions.submittedRevenue,
    isClearFilter: false,
    isDetailsFilterApplied: false,
    selectedRevenueId: null,
    remarksOptions: null,
    dataError : new Map(),
    detailsFilteredData: null,
    cashRegisterMandatory : false,
    isOverviewFilterApplied: false,
    isClearOverviewFilter: false,
    overviewFilterData: [],
    overviewColumnFilterIndexes: []
}

export const OverviewContext = createContext();

export function OverviewProvider(props) {

    const [state, dispatch] = useReducer(overviewReducer, initialState);
    const languageContext = useContext(LanguageContext);
    const { fromMinDate, fromRevenueDate, fromMaxDate, untilMinDate, untilRevenueDate, untilMaxDate, sessionTimeoutLimit,
        idleTimeoutLimit ,overview, overviewDetails, isError, errorMessage, isLoading, isBtnDetailsEnable,  
        isShowDetailsClicked, showDetailRequestModel, isEnableEditableFields,
        isSuccessfullySaved, showModel, showInstructions, modelHeaderTitle, revenueOverviewDetails,
        selectedRevenue, selectedRevenueId, showUploadFileModel, acceptFileType, isFileUploadedSuccessfully,
        isCashRegister, isEditBtnToggle, selectedOverdetailsOption, isClearFilter, isDetailsFilterApplied, 
        remarksOptions, dataError, detailsFilteredData, cashRegisterMandatory, isOverviewFilterApplied, 
        isClearOverviewFilter, overviewFilterData, overviewColumnFilterIndexes } = state;

    const fetchOverviewHandler = async () => {

        dispatch({ type: FETCH_OVERVIEW_REQUEST });

        await fetchOverview()
            .then((data) => {
                dispatch({
                    type: FETCH_OVERVIEW_SUCCESS,
                    payload: {
                        overview: data && typeof(data) !== 'string' ? data : [],
                        isLoading: false
                    }
                });
            })
            .catch((error) => {
                dispatch({
                    type: DISPLAY_ERROR_MESSAGE,
                    payload: {
                        isLoading: false, isError: true,
                        errorMessage: "wentwrong"
                    }
                });
            })
    }

    useEffect(() => {
        props.setSelectedNavItem(window.location.pathname.replace(/[/]/g, ''));
        
        async function fetchMetaDataAsync() {
            await fetchMetaData()
                .then((data) => {
                    dispatch({
                        type: FETCH_DATE_CONFIG,
                        payload: {
                            fromMinDate: data.FromMinDate,
                            fromRevenueDate: data.FromStartDate,
                            fromMaxDate: data.FromMaxDate,
                            untilMinDate: data.ToMinDate,
                            untilRevenueDate: data.ToStartDate,
                            untilMaxDate: data.ToMaxDate,
                            sessionTimeoutLimit: data.sessionTimeoutLimit ? +(data.sessionTimeoutLimit) : null,
                            idleTimeoutLimit: data.sessionTimeoutLimit ? +(data.idleTimeoutLimit) : null
                        }
                    });
                    data.FromStartDate && data.ToStartDate && fetchRemarkOptionsHandler();
                    data.FromStartDate && data.ToStartDate && fetchOverviewHandler();
                })
                .catch((error) => {
                    dispatch({
                        type: DISPLAY_ERROR_MESSAGE,
                        payload: {
                            isError: true,
                            errorMessage: "wentwrong"
                        }
                    });
                })
        }
        fetchMetaDataAsync();
    }, []);

    useEffect(() => {
        if (isBtnDetailsEnable && isShowDetailsClicked) {
            async function fetchOverviewDetailsHandler() {
                showDetailRequestModel && await fetchOverviewDetails(showDetailRequestModel)
                    .then((data) => {
                        dispatch({
                            type: FETCH_OVERVIEWDETAILS_SUCCESS,
                            payload: {
                                overviewDetails: data && typeof(data) !== 'string' ? data : [],
                                revenueOverviewDetails: data && typeof(data) !== 'string' ? data : [],
                                isShowDetailsClicked: false,
                                isLoading: false
                            }
                        });
                    })
                    .catch((error) => {
                        dispatch({
                            type: DISPLAY_ERROR_MESSAGE,
                            payload: {
                                isLoading: false, isError: true,
                                isShowDetailsClicked: false,
                                errorMessage: "wentwrong"
                            }
                        });
                    })
            }
            fetchOverviewDetailsHandler();
        }
    }, [isShowDetailsClicked]);

    const setDataErrorHandler = (key, value, isSet) => { 
        if(isSet)
        {
            if(dataError)
            {
                dataError.set(key, value);
            }
            dispatch({ type: SET_ERROR_LIST, payload: { dataError: dataError } });                    
        } 
        else
        {
            if(dataError && dataError.size > 0)
            {
                dataError.delete(key);
                dispatch({ type: SET_ERROR_LIST, payload : { dataError: dataError } });                 
            }
        }
    }

    const fetchRemarkOptionsHandler = async () => {
        await fetchRemarksOptions()
            .then((data) => {
                dispatch({
                    type: FETCH_REMARK_OPTIONS,
                    payload: {
                        remarksOptions: data && typeof(data) !== 'string' ? data : null
                    }
                });
            })
            .catch((error) => {
                dispatch({
                    type: DISPLAY_ERROR_MESSAGE,
                    payload: {
                        isLoading: false, isError: true,
                        modelHeaderTitle: "updaterevenue",
                        errorMessage: "wentwrong",
                        showModel: true
                    }
                });
            })
    }

    const errorHandler = (isModelError, errorModelMessage, isLoadingError, showErrorModel, modelHeaderTitleError) => {
        dispatch({
            type: DISPLAY_ERROR_MESSAGE,
            payload: {
                isError: isModelError,
                errorMessage: errorModelMessage,
                isLoading: isLoadingError,
                showModel: showErrorModel,
                modelHeaderTitle: modelHeaderTitleError//showModel ? "Update revenue details" : ""
            }
        });
    }

    const fromDateHandler = (selectedDate, isFromDateError, errorFromDateMessage) => {
        if (isFromDateError)
            errorHandler(isFromDateError, errorFromDateMessage, false, false, "");
        else
            dispatch({ type: SET_FROM_DATE, payload: { fromRevenueDate: format(selectedDate, "dd/MM/yyyy") } });
    }

    const untilDateHandler = (selectedDate, isUntilDateError, errorUmtilDateMessage) => {
        if (isUntilDateError)
            errorHandler(isUntilDateError, errorUmtilDateMessage, false, false, "");
        else
            dispatch({ type: SET_UNTIL_DATE, payload: { untilRevenueDate: format(selectedDate, "dd/MM/yyyy") } });
    }

    const handlerOnOverviewDataSelection = (overviewDataOnSelection) => {
        dispatch({ type: SET_OVERVIEW_DATA, payload: { overview: overviewDataOnSelection } });
    }

    const handlerOnShowDetailClick = () => {
        dispatch({ type: FETCH_OVERVIEWDETAILS_REQUEST, 
                   payload: { 
                                fromRevenueDate, 
                                untilRevenueDate, 
                                overview: overviewFilterData && overviewFilterData.length > 0 ? overviewFilterData : overview, 
                                isRevenueSubmitted: selectedOverdetailsOption === OverviewDetailsOptions.submittedRevenue 
                            } 
                });
    }

    const checkIfModification = (backHandler, isErrorExists) => {
        let error = "";
        let isUpdated = false;
        let isModificationError = false;
        
        if (backHandler) {
           dispatch({ type: RESET_EDIT_TOGGLE_ON_BACK });
        }

        if (overviewDetails && overviewDetails.nmbsUserDetailOverviewDtos)
        {
           overviewDetails.nmbsUserDetailOverviewDtos.map((d, index) => {
            if (isUpdated === false && d.isUpdated) {
                    isUpdated = d.isUpdated;
            }
           });
        }   

        if (isErrorExists || isUpdated) {
            error = "modification_notsaved";    
        }
           
        if (error.trim() !== "") {
            isModificationError = true;            
        }

        if (isModificationError) {
            errorHandler(isModificationError, error, false, true, "unsaved_changes")
        }
        else{ 
            if(dataError && dataError.size > 0)
            {
                dataError.clear()
            }
            if (!backHandler){               
                dispatch({ type: DISABLE_EDITABLE_FIELDS,
                     payload: { 
                        revenueOverviewDetails: revenueOverviewDetails,
                        dataError: dataError
                    } });
            }
            else {
                dispatch({ type: BACK_TO_OVERVIEW,
                    payload: { 
                        dataError: dataError
                    } 
                 });
            }
        }
    }

    const handlerOnBackClick = (backError) => {
        checkIfModification(true, backError)
    }

    const handlerOnEditClick = () => {
        dispatch({ type: ENABLE_EDITABLE_FIELDS, payload: { overviewDetails: overviewDetails } });
    }

    const handlerOnEditToggleClick = (editError) => {
        checkIfModification(false, editError)
    }

    const setOverviewRevenueDataHandler = (revenueId, selectedRevenueData, columnName, isTaxAmountColumn, taxPercentage) => {
        dispatch({
            type: SET_OVERVIEWDETAILS_DATA,
            payload: {
                overviewDetails: overviewDetails,
                selectedRevenueId: revenueId,
                selectedRevenue: selectedRevenueData,
                updatedColumnName: columnName,
                isTaxAmountColumn: isTaxAmountColumn,
                taxPercentage: taxPercentage
            }
        });
        dispatch({
            type: SET_OVERVIEWDETAILS_TOTAL_FOOTER_DATA, payload: {
                updatedColumnName: columnName,
                isTaxAmountColumn: isTaxAmountColumn,
            }
        })
    }

    const handlerOnSaveBtnClick = async (isSaveError, saveErrorMessage, updateDetailRequestModel) => {
        if (isSaveError) {
            errorHandler(true, saveErrorMessage, false, true, "updaterevenue");
        } else {
            if (!isNullOrUndefined(updateDetailRequestModel) && updateDetailRequestModel.length > 0) {

                dispatch({ type: SAVE_OVERVIEWDETAILS_REQUEST });

                await updateOverviewRevenueDetails(updateDetailRequestModel)
                    .then((data) => {
                        dispatch({
                            type: SAVE_OVERVIEWDETAILS_SUCCESS,
                            payload:
                            {
                                isSuccessfullySaved: !isNullOrUndefined(data) && data.length > 0,
                                revenueOverviewDetails: !isNullOrUndefined(data) && data.length > 0
                                    ? overviewDetails
                                    : revenueOverviewDetails,
                                savedData: data
                            }
                        });
                    })
                    .catch((error) => {
                        errorHandler(true, "wentwrong", false, true, "updaterevenue");
                    })
            }
            else errorHandler(true, "wentwrong", false, true, "updaterevenue");
        }
    }

    const handleConfirmationYes = () => {
        if(dataError && dataError.size > 0)
        {
            dataError.clear()
        }
        if(isCashRegister && selectedRevenueId > 0 && selectedRevenue) {
            dispatch({ type: SHOW_UPLOAD_FILE_MODEL, 
                payload: {
                    acceptFileType: config.allowesCashRegisterFileExtentions,
                    modelHeaderTitle: "Upload_Cash_Register",
                    selectedRevenueId: selectedRevenueId,
                    selectedRevenue: selectedRevenue,
                    showUploadFileModel: true,
                } 
            });
        }          
        if(isEditBtnToggle)
        {
            dispatch({ type: BACK_TO_OVERVIEW,
                payload: {  dataError : dataError } });                
        }
        else
        {
            if (!isCashRegister)
            {
                dispatch({ type: DISABLE_EDITABLE_FIELDS, 
                payload: { 
                    revenueOverviewDetails: revenueOverviewDetails,
                    dataError: dataError
                }
                });
            }
        }        
    }

    const handlerResetUpdatedAndErrorFlags = () => {
        dispatch({ type: RESET_UPDATED_AND_ERROR_FLAGS });
    }

    const setShowInstructions = (showInstructionsModel) => {
        dispatch({
            type: SET_SHOW_INSTRUCTION_MODEL,
            payload: {
                showModel: showInstructionsModel,
                showInstructions: showInstructionsModel,
                modelHeaderTitle: showInstructionsModel ? "instruction" : ""
            }
        })
    }

    const handlerOnExportToExcelClick = async () => {
        if(languageContext && languageContext.language && showDetailRequestModel) {
        dispatch({type: DETAILOVERVIEW_REQUEST_OR_SUCCESS, payload: {isLoading: true}});
        const selectedLangId = +languageContext.language.id;
        const contractFilter = isDetailsFilterApplied ? detailsFilteredData : null;
        const contractIds = isDetailsFilterApplied ? [] : showDetailRequestModel.ContractIds;
        const businessPartnerIds = isDetailsFilterApplied ? [] : showDetailRequestModel.BusinessPartnerIds;
        const overviewDetailRequestModel = { ...showDetailRequestModel, 
                                             ContractIds: contractIds,
                                             BusinessPartnerIds: businessPartnerIds,
                                             languageId: selectedLangId, 
                                             ContractFilter: contractFilter
                                           };
        await exportToExcelOverviewDetails(overviewDetailRequestModel)    
              .then((data)=>{
                    dispatch({type: DETAILOVERVIEW_REQUEST_OR_SUCCESS, payload: {isLoading: false}});
                    const tempDate = format(new Date(), "ddMMyyyy:HHmmss");
                    const fileName = (showDetailRequestModel.isRevenueSubmitted ? languageContext.labels["detailoverview"] : languageContext.labels["unsubmittedrevenue_export"]) + "_" + tempDate + ".xlsx";
                    saveAs(new Blob([data]), fileName);
            })
            .catch((error)=>{
                dispatch({type: DISPLAY_ERROR_MESSAGE, 
                    payload: {
                            isLoading: false, isError: true, 
                            modelHeaderTitle: "dailyrevenue",
                            errorMessage: "wentwrong",
                            showModel: true
                    }
                });
            })     
        }
    } 

    const handlerOnDownloadCashRegisterClick = async (contractCode, revenueDate, userCashRegisterFileName) => {
       if(isValueNullOrUndefinedOrEmpty(userCashRegisterFileName))
           {
            dispatch({type: DISPLAY_ERROR_MESSAGE, 
                payload: {
                        isLoading: false, isError: true, 
                        modelHeaderTitle: "CashRegister",
                        errorMessage: "cashregisternotfound",
                        showModel: true
                }
            });
           }                                     
       else{
          dispatch({type: DETAILOVERVIEW_REQUEST_OR_SUCCESS, payload: {isLoading: true}});
          await downloadCashRegister(contractCode, revenueDate)    
              .then((data)=>{
                    dispatch({type: DETAILOVERVIEW_REQUEST_OR_SUCCESS, payload: {isLoading: false}});
                    saveAs(new Blob([data]), userCashRegisterFileName);
            })
            .catch((error)=>{
                dispatch({type: DISPLAY_ERROR_MESSAGE, 
                    payload: {
                            isLoading: false, isError: true, 
                            modelHeaderTitle: "CashRegister",
                            errorMessage: "wentwrong",
                            showModel: true
                    }
                });
            })     
        }
    }

    const handlerOnCashRegisterIconClick = (revenueId, selectedRevenueRow) => {
        if (selectedRevenueRow && selectedRevenueRow.userCashRegisterFileName) {
            dispatch({
                type: SHOW_CASH_REGISTER_CONFIRMATION_MODEL,
                payload: {
                    modelHeaderTitle: "Upload_Cash_Register",
                    errorMessage: "modification_cashregister_warning",
                    isLoading: false,
                    showModel: true,
                    isError: true,
                    selectedRevenueId: revenueId,
                    selectedRevenue: selectedRevenueRow,
                    isCashRegister: true
                }
            });
        }
        else {
            dispatch({
                type: SHOW_UPLOAD_FILE_MODEL,
                payload: {
                    acceptFileType: config.allowesCashRegisterFileExtentions,
                    modelHeaderTitle: "Upload_Cash_Register",
                    selectedRevenueId: revenueId,
                    selectedRevenue: selectedRevenueRow,
                    showUploadFileModel: true,
                }
            });
        }
    }

    const handlerOnUploadCashRegisterClick = async (revenueId, selectedRevenueDtl, cashRegisterFile, 
                                                    userCashRegisterFileName, UserId) => {
        dispatch({ type: UPLOAD_CASH_REGISTER_REQUEST});
        let requestFormData = new FormData();
        requestFormData.append("IntakeBookFile", cashRegisterFile)       
        requestFormData.append("BusinessPartnerCode", selectedRevenueDtl.businessPartnerCode);
        requestFormData.append("IntakeBookDate", format(parse(selectedRevenueDtl.revenueDate, "dd/MM/yyyy", new Date()),"MM/dd/yyyy"));
        requestFormData.append("ContractCode", selectedRevenueDtl.contractCode);
        requestFormData.append("CreatedBy", UserId);        
        
        await uploadCashRegister(requestFormData)    
            .then((data)=>{ 
                if(data && data.isSuccess) {
                    dispatch({
                                type: UPLOAD_CASH_REGISTER_SUCCESS,
                                payload: {
                                        selectedRevenueId: revenueId,                                       
                                        userCashRegisterFileName: userCashRegisterFileName,
                                        selectedRevenue: selectedRevenueDtl,
                                        modelHeaderTitle: "updaterevenue",
                                        isCashRegister: false
                                } 
                    });
                } else {
                    dispatch({
                        type: DISPLAY_ERROR_MESSAGE, 
                        payload: {
                            isLoading: false, isError: true, 
                            modelHeaderTitle: "updaterevenue",
                            errorMessage: "wentwrong",
                            showModel: true,
                            isCashRegister: false
                        }
                    });
                }
            })
            .catch((error)=>{
            dispatch({
                        type: DISPLAY_ERROR_MESSAGE, 
                        payload: {
                            isLoading: false, isError: true, 
                            modelHeaderTitle: "updaterevenue",
                            errorMessage: "wentwrong",
                            showModel: true
                        }
                    });
            })     
    }

    const handlerOnLogout = () => {
        dispatch({ type: LOGOUT_YES });
    }

    const handlerToShowUnsavedChanges = () => {
        errorHandler(true, "modification_notsaved", false, true, "unsaved_changes");
    }

    const handlerSelectedOptionChange = (selectedOption) => {
        dispatch({type: SELECTED_OVERVIEWDETAIL_OPTION_CHANGE, 
                  payload: {selectedOverdetailsOption: selectedOption}  
                })
    }

    const handlerOnClearFilterClick = (isClear, isOverviewFilter) => {
        if(isOverviewFilter) {
            dispatch({ 
                type: CLEAR_OVERVIEW_FILTER,
                payload: {isClearOverviewFilter: isClear, overviewFilterData: []} 
            });
        } else {
            dispatch({ type: CLEAR_FILTER, payload: {isClearFilter: isClear} });
        }
    }

    const handlerCheckDetailsFilterApplied = (isFilterApplied, dtlFilteredData) => {
        let exportFilterDataObj=null;
        if(dtlFilteredData && dtlFilteredData.length > 0) {
            exportFilterDataObj=dtlFilteredData.map(d=> { 
                return {
                   "contractId" : d.contractId,
                   "revenueDate" : format(parse(d.revenueDate, "dd/MM/yyyy", new Date()),"MM/dd/yyyy" )
                }
            })
        }

        dispatch(
                    { 
                        type: IS_DETAILS_FILTER_APPLIED, 
                        payload: {
                        isDetailsFilterApplied: isFilterApplied,
                        detailsFilteredData: exportFilterDataObj
                        } 
                    }
        );
    }

    const setCashRegisterMandatory = (flag) =>
    {
        dispatch({ type: SET_CASH_REGISTER_MANDATORY , payload: {cashRegisterMandatory : flag}});
    }

    const handlerCheckOverviewFilterApplied = (isAppliedFilter, filterData, columnIndexes) => {
        dispatch({ type: IS_OVERVIEW_FILTER_APPLIED,
                   payload: {isOverviewFilterApplied: isAppliedFilter, overviewFilterData: filterData, 
                             overviewColumnFilterIndexes: columnIndexes} 
                });
    }

    const handlerSetOverviewFilterData = (filterData, selctedFilterColumnIndexes) => {
        dispatch({ type: SET_OVERVIEW_FILTER_DATA, 
                   payload: {overviewFilterData: filterData, overviewColumnFilterIndexes: selctedFilterColumnIndexes} });
    }

    const provider = {
        fromMinDate,
        fromRevenueDate,
        fromMaxDate,
        untilMinDate,
        untilRevenueDate,
        untilMaxDate,
        sessionTimeoutLimit,
        idleTimeoutLimit,
        fromDateHandler: fromDateHandler,
        untilDateHandler: untilDateHandler,
        overview,
        overviewDetails,
        overviewDataSelectionHandler: handlerOnOverviewDataSelection,
        isError,
        errorMessage,
        isLoading,
        isBtnDetailsEnable,
        isShowDetailsClicked,
        handlerOnShowDetail: handlerOnShowDetailClick,
        handlerOnBackBtnClick: handlerOnBackClick,
        isEditAccess: props.isEditAccess,
        isEditBtnToggle,
        isEnableEditableFields,
        handlerOnEditBtnClick: handlerOnEditClick,
        handlerOnEditBtnToggleClick : handlerOnEditToggleClick,
        setOverviewRevenueData: setOverviewRevenueDataHandler,
        isSuccessfullySaved,
        showModel,
        showInstructions,
        modelHeaderTitle,
        handlerOnSaveClick: handlerOnSaveBtnClick,
        showInstructionsHandler: setShowInstructions,
        showUploadFileModel,
        acceptFileType,
        isFileUploadedSuccessfully,
        selectedRevenue, 
        selectedRevenueId,
        isCashRegister,
        selectedOverdetailsOption,
        isClearFilter,
        isDetailsFilterApplied,
        remarksOptions,
        detailsFilteredData,
        isClearOverviewFilter,
        isOverviewFilterApplied,
        overviewFilterData,
        overviewColumnFilterIndexes,
        handlerResetUpdatedAndErrorFlags,
        handleConfirmationYesClick: handleConfirmationYes,
        handlerOnExportToExcelClick,
        handlerOnDownloadCashRegisterClick,
        handlerOnCashRegisterIconClick,
        handlerOnUploadCashRegisterClick,
        handlerToShowUnsavedChanges,
        handlerOnLogout,
        handlerSelectedOptionChange,
        handlerOnClearFilterClick,
        handlerCheckDetailsFilterApplied,
        setDataErrorHandler,
        dataError,
        cashRegisterMandatory,
        setCashRegisterMandatory,
        handlerCheckOverviewFilterApplied,
        handlerSetOverviewFilterData
        };

    return (
        <OverviewContext.Provider value={provider}>
            {props.children}
        </OverviewContext.Provider>
    );
}